import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-action-loader',
  template: `
    <div class="w-full h-full">
      <ng-content></ng-content>
      <mat-progress-bar
        [ngClass]="{
          'button-progress-bar-hidden': !isRunning(),
          'button-progress-bar-visible': isRunning()
        }"
        mode="indeterminate"
        class="m-t-5"
      ></mat-progress-bar>
    </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatProgressBarModule]
})
export class ActionLoaderComponent {
  isRunning = signal<boolean>(false);

  public start() {
    this.isRunning.set(true);
  }

  public stop() {
    this.isRunning.set(false);
  }
}
